import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";

@Directive()
export abstract class AbstractEtlUpdateComponent {
    @Input() id: string = null;
    @Input() tenant: string = null;
    @Input() partner: string = null;
    @Output() nextStep = new EventEmitter<{ uuid: string; tenant?: string; partner?: string; name?: string }>();
    @Output() previousStep = new EventEmitter<string>();

    @Input() complet: boolean;
    @Output() completChange = new EventEmitter<boolean>();

    constructor(
        protected router: Router,
        protected confirmationService: ConfirmationService,
        protected translate: TranslateService
    ) {}

    goToListEtl(event: Event) {
        this.confirmationService.confirm({
            target: event.target,
            message: this.translate.instant("etl.new.confirm"),
            icon: "pi pi-exclamation-triangle",
            acceptLabel: this.translate.instant("common.True"),
            rejectLabel: this.translate.instant("common.False"),
            accept: () => {
                this.router.navigate(["/h/flux/import-v1/etl"]);
            },
            reject: () => {
                // reject action
            },
        });
    }

    goToPreviousStep() {
        this.previousStep.emit(this.id);
    }
}
